import React from 'react';

import {
	BreadcrumbsList,
	BreadcrumbsListItem,
	LargeBreadcrumbListItem,
} from './styles';

export const Breadcrumbs = ({ options, onClick }) => {
	return (
		<BreadcrumbsList>
			{options.map(
				({ label, value }, index) =>
					options.length === 1 ? (
						<LargeBreadcrumbListItem key={value + index}>
							{label}
						</LargeBreadcrumbListItem>
					) : (
						<BreadcrumbsListItem
							key={value + index}
							onClick={
								index === options.length - 1
									? null
									: () => onClick(value, index)
							}
						>
							{label}
						</BreadcrumbsListItem>
					)
			)}
		</BreadcrumbsList>
	);
};

export default Breadcrumbs;
